<template>
	<div id="CapabilityView">
		<div id="CapabilityViewInner">
			<div class="CapabilityViewItem" v-for="( capability, index ) in capabilities" :class="getClasses(capability, index)">
				<span v-if="showIndex" class="Index">{{index + 1}}</span>
				<span class="Title">{{capability.title}}:</span>
				<span class="Value">{{capabilitiesValues[capability.id]}}</span>
                <span v-if="capability.units">{{capability.units}}</span></span>
            </div>
		</div>
	</div>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';
	import KeyListenerView from '../KeyListenerView';

	@Component({
		components: {},
	})
	export default class CapabilityView extends Vue {
		@Prop(Array) capabilities;
		@Prop(Object) capabilitiesValues;
		@Prop(Boolean) showIndex;
		selectedIndex = 0;

		getClasses(item, index) {
			const itemClasses = item.class && Array.isArray(item.class) ?
				item.class.reduce((obj, cls) => Object.assign(obj, { [cls]: true }), {}) :
				item.class || {};
			return { ...itemClasses, Selected: item.selected, Active: this.selectedIndex === index };
		}
	}
</script>

<style lang="scss">
	#CapabilityView {
		background: #0002A0;
		padding: 3px;
	}

	#CapabilityViewInner {
		color: white;
		border: 2px solid #00FFFE;
		border-top-width: 1px;
		border-bottom-width: 1px;
	}

	.CapabilityViewItem {
		padding: 0.1vmin 0.5vmin;

		> .active {
			background: #FDFD67;
		}
	}

    .CapabilityViewItem .Value {
        padding-left: 4px;
    }
	.CapabilityViewItem.Active {
		background: #FDFD67;
	}
	.CapabilityViewItem.Active .Index {
		color: red;
	}
	.CapabilityViewItem.Active .Title {
		color: red;
	}

	.CapabilityViewItem.Selected {
		background: #ADAAAD;
	}

	.CapabilityViewItem .Index {
		color: #FDFD67;

	}

	.CapabilityViewItem .Index:after {
		content: ") ";
	}
</style>